import type { ChatItem } from '@heidi/agents/contracts';
import { OPTIMISTIC_FIRST_TURN_ITEM_ID } from '@heidi/agents/data';

import type { CreditAllowanceRefusal } from '@heidi/commerce';

export const CREDIT_ALLOWANCE_GHOST_ITEM_ID = 'credit-allowance-ghost';

function ghostItem(text: string): ChatItem {
  return {
    kind: 'user_message',
    id: CREDIT_ALLOWANCE_GHOST_ITEM_ID,
    text,
    attachments: [],
  };
}

function replaceAt(items: ChatItem[], index: number, item: ChatItem): ChatItem[] {
  const next = items.slice();
  next[index] = item;
  return next;
}

/** Append or replace a local user bubble when 402 withdrew the optimistic turn. */
export function mergeCreditAllowanceGhost(
  items: ChatItem[],
  refusal: CreditAllowanceRefusal | null,
  projectId: string
): ChatItem[] {
  if (!refusal?.ghostText || refusal.projectId !== projectId) {
    return items;
  }

  const ghost = ghostItem(refusal.ghostText);

  const ghostIndex = items.findIndex(
    (item) => item.id === CREDIT_ALLOWANCE_GHOST_ITEM_ID
  );
  if (ghostIndex >= 0) {
    const existing = items[ghostIndex];
    if (existing?.kind === 'user_message' && existing.text === refusal.ghostText) {
      return items;
    }
    return replaceAt(items, ghostIndex, ghost);
  }

  const optimisticIndex = items.findIndex(
    (item) => item.id === OPTIMISTIC_FIRST_TURN_ITEM_ID
  );
  if (optimisticIndex >= 0) {
    return replaceAt(items, optimisticIndex, ghost);
  }

  return [...items, ghost];
}
